import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center bg-brand-dark text-brand-cream overflow-hidden py-10 md:py-16 px-4" data-id="element-91">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-leaf-pattern opacity-50 pointer-events-none" data-id="element-92" />

      <div className="max-w-5xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-3 inline-block px-4 py-1.5 border border-brand-gold/30 rounded-full bg-brand-medium/30 backdrop-blur-sm" data-id="element-94">
          <p className="text-sm md:text-base text-brand-lightGold font-medium tracking-wide" data-id="element-95">
            Para mujeres que comen saludable todo el día... hasta que el antojo
            las vence.
          </p>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-balance" data-id="element-96">
          La Razón Científica Por la Que No Puedes Parar de Comer a las 3pm —{' '}
          <br className="hidden md:block" data-id="element-97" />
          <span className="text-brand-gold" data-id="element-98">
            Y Las 25 Recetas que Apagan Ese Antojo en Menos de 10 Minutos
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-brand-cream/90 mb-6 max-w-3xl font-light" data-id="element-99">
          Sin dietas. Sin restricciones. Sin culpa. Solo el snack correcto en el
          momento correcto.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mb-6 relative" data-id="element-100">
          <div className="absolute -inset-4 bg-brand-gold/20 blur-2xl rounded-full" data-id="element-101" />
          <img src="https://cdn.magicpatterns.com/uploads/p3q6Hb6msyCehNqLg2mATK/snack_sin_antojo.png" alt="Snack Sin Antojo - 25 Recetas Inteligentes" className="relative w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto rounded-2xl shadow-2xl border border-brand-gold/20" data-id="element-102" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex flex-col items-center w-full max-w-2xl" data-id="element-103">
          <div className="bg-brand-medium/40 backdrop-blur-sm border border-brand-gold/20 rounded-2xl px-6 py-5 text-center" data-id="element-104">
            <p className="text-lg md:text-xl text-brand-cream font-medium leading-relaxed" data-id="element-105">
              Cada receta incluye el{' '}
              <span className="text-brand-gold font-semibold" data-id="element-106">paso a paso</span>{' '}
              más la{' '}
              <span className="text-brand-gold font-semibold" data-id="element-107">
                información sobre calorías y proteína
              </span>{' '}
              para que tomes decisiones inteligentes sobre lo que comes.
            </p>
          </div>

          <div className="flex items-center gap-2 mt-4 text-sm text-brand-cream/70 font-medium" data-id="element-108">
            <span data-id="element-109">25 recetas</span>
            <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-110" />
            <span data-id="element-111">Con fotos</span>
            <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-112" />
            <span className="text-brand-lightGold" data-id="element-113">Tabla De Sustituciones</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex flex-col items-center w-full" data-id="element-114">
          <div className="flex items-center gap-2 text-sm text-brand-cream/70 font-medium" data-id="element-115">
            <span data-id="element-116">Acceso inmediato</span>
            <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-117" />
            <span data-id="element-118">PDF</span>
            <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-119" />
            <span className="text-brand-lightGold" data-id="element-120">Precio de lanzamiento</span>
          </div>
        </motion.div>
      </div>
    </section>;
}